export const imageNames = [
    'Eng-img2.jpeg',
    'Eng-img3.jpeg',
    'Eng-img5.jpeg',
    'Eng-img7.jpeg',
    'Eng-img4.jpeg',
 ];